<script setup lang="ts">
import { SOCIAL_PROFILE_URLS } from "@/utils/socialProfiles";

const [facebookUrl, instagramUrl, xUrl] = SOCIAL_PROFILE_URLS;
</script>

<template>
  <section class="footer-contact">
    <div class="contact-info">
      <h2>Contact Mont Blanc Treks for Specialist Help and Advice</h2>
      <div class="contact-email"></div>
      <NuxtLink class="btn" to="/get-in-touch"> Contact Us </NuxtLink>
    </div>
    <div class="contact-social">
      <NuxtPicture
        class="social-bg"
        loading="lazy"
        src="/images/social-bg.jpg"
        width="700"
        height="231"
        alt="A beautiful view of mountains in sunset"
      />
      <div class="overlay"></div>
      <div class="social-links">
        <h3>Find us on Socials</h3>
        <ul>
          <li>
            <NuxtLink
              :to="facebookUrl"
              aria-label="Find us on Facebook"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                <path d="M27,36H12V6H31.5V23.9l-4.5,3.05v9.05Z" fill="#fff" />
                <path
                  d="M27,0H9C4.04,0,0,4.04,0,9V27c0,4.96,4.04,9,9,9h9v-15h-2.1c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h2.1v-2.66c0-3.49,2.84-6.34,6.34-6.34h3.26c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5h-3.26c-1.84,0-3.34,1.5-3.34,3.34v2.66h6c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5h-6v15h6c4.96,0,9-4.04,9-9V9c0-4.96-4.04-9-9-9Z"
                  fill="#003149"
                />
              </svg>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink
              :to="instagramUrl"
              aria-label="Find us on Instagram"
            >
              <svg
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M32.6999 3.60156H3.8999V31.5016H32.6999V3.60156Z"
                  fill="white"
                />
                <path
                  d="M24.5728 18.0414C24.5728 21.6884 21.6056 24.6556 17.9586 24.6556C14.3116 24.6556 11.3444 21.6884 11.3444 18.0414C11.3444 14.3944 14.3116 11.4272 17.9586 11.4272C21.6056 11.4272 24.5728 14.3942 24.5728 18.0414ZM36 9V27C36 31.9626 31.9626 36 27 36H9C4.0374 36 0 31.9626 0 27V9C0 4.0374 4.0374 0 9 0H27C31.9626 0 36 4.0374 36 9ZM27.8172 18.0414C27.8172 12.6052 23.3948 8.1828 17.9586 8.1828C12.5224 8.1828 8.1 12.6052 8.1 18.0414C8.1 23.4776 12.5224 27.9 17.9586 27.9C23.3948 27.9 27.8172 23.4776 27.8172 18.0414ZM31.5 6.8436C31.5 5.5494 30.4506 4.5 29.1564 4.5C27.8622 4.5 26.8128 5.5494 26.8128 6.8436C26.8128 8.1378 27.8622 9.1872 29.1564 9.1872C30.4506 9.187 31.5 8.1378 31.5 6.8436Z"
                  fill="#003149"
                />
              </svg>
            </NuxtLink>
          </li>
          <li>
            <NuxtLink
              :to="xUrl"
              aria-label="Find us on X"
            >
              <svg
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.79953 35.875C9.35555 35.875 8.92663 35.7142 8.59185 35.4219C7.8285 34.7557 7.7494 33.5926 8.41563 32.8293L18.4039 21.1801L20.7367 24.0961L11.1843 35.2455C10.8355 35.6456 10.3308 35.875 9.79953 35.875ZM21.2633 17.9039L30.8156 6.75447C31.1644 6.3546 31.6693 6.125 32.2006 6.125C32.6445 6.125 33.0737 6.286 33.4084 6.57825C34.1718 7.24448 34.2507 8.40753 33.5845 9.17088L23.5962 20.8201L21.2633 17.9039Z"
                  fill="#212121"
                />
                <path
                  d="M35.5874 33.7426L14.2374 6.61763C13.9883 6.3063 13.6114 6.125 13.2126 6.125H7.43757C6.93305 6.125 6.47315 6.4141 6.25457 6.86893C6.036 7.32375 6.09742 7.86345 6.4126 8.25738L27.7626 35.3824C28.0116 35.6937 28.3888 35.875 28.7874 35.875H34.5624C35.0669 35.875 35.5268 35.5859 35.7454 35.1311C35.964 34.6762 35.9025 34.1365 35.5874 33.7426Z"
                  fill="#003149"
                />
              </svg>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
